// TODO: For new job polling (e.g. add payment), call this.pollJobStatus with action, params, and callbacks.
const JobStatusPoller = {
  methods: {
    pollJobStatus({ action, params, interval = 1000, onProcessing, onCompleted, onFailed }) {
      const poll = setInterval(async () => {
        try {
          const result = (await this.$store.dispatch(action, params)) || {};
          const { status, step, error } = result;
          if (status === 'processing' || status === 'queued') {
            if (onProcessing) onProcessing(step);
          } else if (status === 'completed') {
            clearInterval(poll);
            if (onCompleted) onCompleted(result);
          } else {
            clearInterval(poll);
            onFailed(error && (error.message || error));
          }
        } catch (e) {
          clearInterval(poll);
          onFailed(e.message);
        }
      }, interval);
    },
  },
};

export default JobStatusPoller;
